import { WorksheetRootComponent } from 'Components/Worksheets/Core';
import ids from '../../QestIds';
import { BsEnDryMassesSection, BsEnMeasurementsSection, BsEnPreparationSection } from './Sections';

const qestIds = [ids.moistureContent.BS_EN_1097_5.rev2008];

let BsEnMeasuredMoistureContentWorksheet: WorksheetRootComponent = () => (
  <>
    <BsEnPreparationSection isEmbeddedTest />
    <BsEnMeasurementsSection isEmbeddedTest />
    <BsEnDryMassesSection isEmbeddedTest />
  </>
);

BsEnMeasuredMoistureContentWorksheet.qestIds = qestIds;

export default BsEnMeasuredMoistureContentWorksheet;
export { BsEnMeasuredMoistureContentWorksheet };
